export const GET_WALLET_DETAILS_SUCCESS = 'GET_WALLET_DETAILS_SUCCESS';
export const GET_WALLET_DETAILS_REQUEST = 'GET_WALLET_DETAILS_REQUEST';
export const GET_WALLET_DETAILS_FAILURE = 'GET_WALLET_DETAILS_FAILURE';
export const GET_WALLET_DETAILS_RESET = 'GET_WALLET_DETAILS_RESET';
export const getWalletDetailsSuccess = (payload) => ({
    type: GET_WALLET_DETAILS_SUCCESS,
    payload,
});
export const getWalletDetailsRequest = (payload) => ({
    type: GET_WALLET_DETAILS_REQUEST,
    payload,
});
export const getWalletDetailsFailure = (payload) => ({
    type: GET_WALLET_DETAILS_FAILURE,
    payload,
});
export const getWalletDetailsReset = () => ({
    type: GET_WALLET_DETAILS_RESET,
});
